import React, { useRef, useState } from "react";
import { InputText } from "primereact/inputtext";
import { useFormik } from 'formik';
import * as Yup from "yup";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import giftPng from "../../../assets/imgs/open-gift.png"
import { Image } from "primereact/image";
import "../inviteFriends/inviteFriend.css"
import Avatar from "react-avatar-edit";
import { Toast } from 'primereact/toast';
const InviteFriends = () => {
    const [saveBtnLoading, setSaveBtnLoading] = useState(false);
    const [userInviteCode, setUserInviteCode] = useState([]);
    const [loading, setLoading] = useState(false)
    const history = useHistory();
    const dispatch = useDispatch();
    const userId = useSelector((state) => state.authenticationSlice?.userId);
    const mobile = useSelector((state) => state.authenticationSlice?.mobile)
    const inviteCode = useSelector((state) => state.authenticationSlice?.inviteCode);
    console.log(inviteCode, "invite")

    const [visible, setVisible] = useState(false);
    const toastBC = useRef(null);
    const toast = useRef(null);

    // const show = () => {
    //     toast.current.show({ severity: 'info', summary: 'Info', detail: "Invite code copied to clipboard!" });
    // };
    const formik = useFormik({
        initialValues: {
            inviteCode: inviteCode,
        },

        onSubmit: async (data) => {
            setSaveBtnLoading(true);
            if (!data.inviteCode) {
                toast.warn("No invite code available!");
                return;
            }
            await handleShare(data.inviteCode);
            console.log(data)

            setSaveBtnLoading(false);

        },
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    const handleCopy = (code) => {
        if (code) {
            navigator.clipboard
                .writeText(code)
                .then(()=>  toast.current.show( { severity: 'success', summary: 'Copied',detail: "Invite code copied to clipboard!", }))
                .catch(() => toast.current.show({ severity: 'error', summary: 'Failed To copy', detail: "Failed to copy invite code." } ))
        } else {
            toast.current.show({ severity: 'warn', summary: 'Warn', detail: "Failed to copy invite code." } )
        }
    };

    const handleShare = async (inviteCode) => {
        setSaveBtnLoading(true);
        //domain link instaed of localhost
        const inviteLink = `http://localhost:3000/invite?code=${inviteCode}`;
        console.log(inviteLink)
        try {
            if (navigator.share) {
                await navigator.share({
                    title: "Invite Friends",
                    text: "Join us and get free points! Use this invite code.",
                    url: inviteLink,
                });
            } else {
                toast.info("Sharing is not supported on this device. Use the copy link option.");
            }
        } catch (error) {
            toast.error("Error sharing the invite link.");
        } finally {
            setSaveBtnLoading(false);
        }
    };


    return (

        <>
            <Toast ref={toast} />
            <form onSubmit={formik.handleSubmit}>
                <div className="flex login-main-body align-items-center justify-content-center overflow-hidden">
                    <div className="login-div-border ">
                        <div className="w-full surface-card py-8 px-5 sm:px-6">
                            <div className="text-center mb-3">
                                <Image src={giftPng} alt="Image"
                                    height="150"
                                    width="150"
                                    className="ml-8 mb-5"
                                />
                                <div className="text-3xl font-bold mb-3 mt-3" style={{ color: 'whitesmoke' }}>
                                    Invite Friends
                                    <br></br>
                                    To Get Free Points
                                </div>
                                <p>
                                    When your friend sign up with this code, you'll
                                    <br></br>
                                    both get extra points
                                </p>
                            </div>

                            <div className="login-div">
                                <div className="col-12">
                                    <div className="mb-3 flex input-wrapper">
                                        <InputText disabled={true} className="bg-transparent text-white custom-placeholder w-full mb-2 p-1 pb-3 invite-input-border" id='inviteCode' type="text" name="inviteCode" placeholder="Enter Invite Code" value={formik.values.inviteCode} onChange={formik.handleChange} />
                                        {getFormErrorMessage("inviteCode")}
                                        <i className="pi pi-clone invite-input-icon"
                                            style={{ cursor: "pointer", marginLeft: "10px" }}
                                            onClick={() => {
                                                handleCopy(formik.values.inviteCode)
                                            }
                                            }
                                        ></i>
                                    </div>
                                </div>
                                <Button label="Share" loading={saveBtnLoading} type="submit" className="w-full mt-3 mb-1 p-3 text-xl font-medium" />
                            </div>
                        </div>

                    </div>
                </div>
            </form>
        </>

    );
};

export default InviteFriends;
